import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import AccordionContext from './context/accordion-context';
import useOpenStatus from './hooks/use-open-status';
import noop from '../utils/noop';

function AccordionHeader({
  component: Component = 'div',
  itemId,
  onClick = noop,
  children,
  ...otherProps
}) {
  const { toggleItemOpen } = useContext(AccordionContext);
  const isOpen = useOpenStatus(itemId);
  const toggleOpen = useCallback(() => {
    onClick(itemId, isOpen);
    toggleItemOpen(itemId);
  }, [toggleItemOpen, itemId, isOpen, onClick]);

  return (
    <Component {...otherProps} onClick={toggleOpen}>
      {typeof children === 'function' ? children(isOpen) : children}
    </Component>
  );
}

AccordionHeader.propTypes = {
  component: PropTypes.elementType,
  itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  onClick: PropTypes.func,
};

export default AccordionHeader;
